import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityInvitationsAcceptPostSlice } from './post';

export const securityInvitationsAcceptReducers = combineReducers({
	post: securityInvitationsAcceptPostSlice.asyncReducers
});

export const securityInvitationsAcceptWatchers = combineAllWatchers([
	securityInvitationsAcceptPostSlice.asyncWatchers
]);
